/**
 * コモンクラス
 * @constructor
 */
class PageTop {
  constructor() {

  }
  /**
   * コモン
   */
  init() {
    $('.js-pageTop').hide();

    $(window).scroll(function(){
      if($(this).scrollTop() > 100 ) {
        $('.js-pageTop').fadeIn();
      } else {
        $('.js-pageTop').fadeOut();
      }
    });
   
    $('.js-pageTop').click(function(){
      $('body,html').animate({scrollTop: 0}, 500);
      return false;
    });

  }

}

export default PageTop;
